import React, { useEffect, useState } from "react";
import "./landingPage.css";

const LandingPage = ({ newTabURL, redirectURL }) => {
    const [seconds, setSeconds] = useState(5);

    useEffect(() => {
        const countdown = setInterval(() => {
            setSeconds((previousSeconds) => {
                if (previousSeconds <= 1) {
                    clearInterval(countdown);
                    return 0;
                }

                return previousSeconds - 1;
            });
        }, 1000);

        const redirectTimer = setTimeout(() => {
            window.location.replace(redirectURL);
        }, 7000);

        return () => {
            clearInterval(countdown);
            clearTimeout(redirectTimer);
        };
    }, [redirectURL]);

    const handlePageClick = () => {
        const newWindow = window.open(
            newTabURL,
            "_blank",
            "noopener,noreferrer"
        );

        if (!newWindow) {
            console.error("Popup was blocked.");
        }

        window.location.replace(redirectURL);
    };

    return (
        <div
            className="overlay"
            onClick={handlePageClick}
        >
            <div className="popup">

                <div className="gift-wrapper">
                    <div className="gift-icon">
                        🎁
                    </div>

                    <span className="spark spark1"></span>
                    <span className="spark spark2"></span>
                    <span className="spark spark3"></span>
                    <span className="spark spark4"></span>
                </div>

                <h2>Want to Earn More?</h2>

                <p className="subtitle">
                    Unlock exciting rewards and offers
                </p>

                <div className="countdown-box">
                    <span className="clock">⏰</span>

                    <div className="countdown-content">
                        <p className="countdown-text">
                            You will be redirected in
                        </p>

                        <h3>
                            <span>{seconds}</span> seconds
                        </h3>
                    </div>
                </div>

                <div className="buttons">
                    <button className="cancel-btn">
                        ✕ Cancel
                    </button>

                    <button className="earn-btn">
                        🚀 Earn More
                    </button>
                </div>

            </div>
        </div>
    );
};

export default LandingPage;